import { useContext } from 'react'

import Context from './context'

const useCheckoutContext = () => {
  const context = useContext(Context)
  if (context === undefined) {
    throw new Error('Checkout context is not correctly defined')
  }
  return context
}

export default useCheckoutContext
